module.exports = __webpack_public_path__ + "img/speed.c0bbe650.svg";